"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterDiscountsBySalesChannel = exports.sortDiscountsByLoyaltyCostAndDate = void 0;
// Utility function to sort a list of IDiscount by loyaltyCost and then by updateDate
const sortDiscountsByLoyaltyCostAndDate = (discounts) => {
    return discounts.sort((a, b) => {
        if (a.loyaltyCost < b.loyaltyCost) {
            return 1;
        }
        else if (a.loyaltyCost > b.loyaltyCost) {
            return -1;
        }
        else {
            return new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime();
        }
    });
};
exports.sortDiscountsByLoyaltyCostAndDate = sortDiscountsByLoyaltyCostAndDate;
const filterDiscountsBySalesChannel = (discounts, salesChannel) => {
    return discounts.filter((discount) => {
        var _a, _b;
        return ((_a = discount.salesChannels) === null || _a === void 0 ? void 0 : _a.length) === 0 ||
            ((_b = discount.salesChannels) === null || _b === void 0 ? void 0 : _b.some((s) => s.id === salesChannel.id));
    });
};
exports.filterDiscountsBySalesChannel = filterDiscountsBySalesChannel;
//# sourceMappingURL=discountsUtilities.js.map